import { render, staticRenderFns } from "./lookSysStudentDo.vue?vue&type=template&id=ef5b3068&scoped=true&"
import script from "./lookSysStudentDo.vue?vue&type=script&lang=js&"
export * from "./lookSysStudentDo.vue?vue&type=script&lang=js&"
import style0 from "./lookSysStudentDo.vue?vue&type=style&index=0&id=ef5b3068&scoped=true&lang=scss&"
import style1 from "./lookSysStudentDo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5b3068",
  null
  
)

export default component.exports